<template>
   <div>
      <div v-show=" !locked || selected">
         <div data-toggle="tooltip" data-html="true" title="">
            <div
               :class="locked ? 'unit-locked':'unit pointer'"
               @click="select"
            >
               <span v-if="this.searching || this.pSearching" class="fas fa-circle-notch fa-spin theme-calc rel-loader"></span>
               <span v-else-if="this.error" class="fas fa-unlink"></span>
               <span v-else-if="!this.selected" class="fad fa-check-circle grey"></span>
               <span v-else-if ="!locked" class="fad fa-check-circle green"></span>
               <div class="code-title flex-grow-1">
                  <span v-if="data.code" class="unit-code">{{ data.code }}</span>
                  <span v-if="data.courseCode" class="unit-code">{{ data.courseCode }}</span>
                  <span class="unit-title">{{ data.name }}</span>
               </div>
               <div class="fee-creds" v-if="data.type || !data.requiredCredits">
                  <span v-if="data.type" :class="'feeNcreds ' + typeClass">{{ data.type }}</span>
                  <span v-if="this.duplicate" class="feeNcreds" data-toggle="tooltip" data-html="true" :title="dupTip"> Duplicate </span>
                  <span class="feeNcreds" v-if="!this.duplicate">Credits: {{ data.credits }}</span>
                  <span v-if="this.data.type === 'Unit' && !this.duplicate" class="feeNcreds">Fees: $
                     <span v-if="this.loading" > - </span>
                     <span v-else >{{ fee }}</span>
                  </span>
                  <span class="unit-link" v-if="this.link" @click.stop><a :href="this.link" target="_blank"><i class="far fa-external-link link-grey"></i></a></span>
                  <!-- <span class="unit-link" v-if="this.link" @click.stop @click="openClose()"><i :class="['far fa-chevron-down right rotate', extraInfoShow ? 'down' : '',]"></i></span> -->
               </div>
               <div class="fee-creds" v-else>
                  <span class="feeNcreds">Credits: {{ data.requiredCredits }}</span>
               </div>
            </div>
            <transition name="slide">
               <div class="unit-offerings" v-if="extraInfoShow">
                  <div>
                     <div class="offerings-title"> Offerings:</div>
                     <!-- <div class="unit-offering legend">
                        <span class="title flex-grow-1">Offering location</span>
                        <div class="attributes">
                           <span class="attribute">Teaching period code</span>
                           <span class="attribute">Attendance mode</span>
                        </div>
                     </div> -->
                     <span v-for="offering in this.offerings" :key="offering.id">
                        <div class="unit-offering" v-if="offering.published">
                           <span class="title flex-grow-1">{{ offering.location.name }}</span>
                           <div class="attributes">
                              <span class="attribute">{{ offering.teachingScheduled }}</span>
                              <span class="attribute">{{ offering.attendanceMode }}</span>
                           </div>
                        </div>
                     </span>
                  </div>
               </div>
            </transition>
         </div>
         <div class="str-rel-error" v-if="error">
            <!-- <ApiError :error="error" @errorClicked="closeError" /> -->
         </div>
         <div v-if="!item && searching"><Loading/></div>
         <div v-if="item && !searching">
            <Structure :data="item.structure[0]" @creditUpdate="updateCredits" :location="location" />
         </div>
      </div>
   </div>
</template>

<script>
   import { mapState, mapActions } from 'vuex'
   import {getFees} from 'common/models/fees.js'
   import Loading from "client/components/murdoch/Loading.vue"
   import ApiError from "client/components/murdoch/ApiError.vue"

   export default {
      name: "Relationship",
      components: {
         Structure: () => import('./structure.vue'),
         Loading,
         ApiError
      },
      props: {
         data: {
            type: Object,
            required: true
         },
         location: {
            type: String,
            required: false,
         },
         pSearching: {
            type: Boolean,
            required: false,
            default: false,
         },
      },
      data: function(){
         return {
            item: null,
            error: false,
            credits: 0,
            loading: false,
            searching: false,
            dupTip: "",
            extraInfoShow: false,
         }
      },
      beforeMount: function(){
         switch(this.data.type){
            case "Unit":
               if(this.selected) {
                  this.credits = parseFloat(this.data.credits)
               }else{
                  this.credits = 0
               }
            break;
            default:
         }
      },
      beforeDestroy() {
         //console.log("Killing " + this.data.code);
         var d = this.data;
         d.location = this.location;
         this.removeSelectedItem(d);
         this.item = null;
         this.credits = 0;
      },
      computed: {
         ...mapState({
            selectedItems: state => state.selections.selectedItems,
            locked: state => state.selections.locked,
            course: state => state.selections.course,
            fees: state => !state.fee.setUpdatingFees && state.fee.fees,
            handbookURL: state => state.global.URLs["handbook"],
         }),
         selected: function(){
            return this.selectedItems.filter(item => item.id === this.data.id && item.location === this.data.location).length > 0 ? true : false;
         },
         duplicate: function(){
            const result = this.selectedItems.find(item => item.id === this.data.id)
            if(result && result.location != this.data.location){
               this.dupTip = result.location.replace(/-\d*>/g, ">");
               this.dupTip = "This is already counted in: "+ this.dupTip.substring(0, this.dupTip.lastIndexOf('>'))
               return true;
            }else{
               this.dupTip = "";
               return false;
            }
         },
         fee: function(){
            if(this.data.unit || this.data.fieldOfEducation){
               if(this.course){
                  return getFees({unit: this.data, fees: this.fees, courseCode: this.course.code, courseAbbreviation: this.course.abbreviation, log: true});
               }else{
                  return getFees({unit: this.data, fees: this.fees, courseCode: null, courseAbbreviation: null, log: true});
               }
            }
         },
         typeClass: function(){
            switch(this.data.type){
               case "Unit":
                  return "rel-unit"
               break;
               case "Major":
                  return "rel-major"
               break;
               default:
                  return "";
            }
         },
         link: function(){
            var url = this.handbookURL
            if(this.data.type == "Unit"){
               if(this.data.unit){
                  return url + "units/"+this.data.unit.courseLoopVersionNumber+"/"+this.data.code;
               }else{
                  return url + "units/"+this.data.version+"/"+this.data.code;
               }
            }
         },
         offerings: function(){
            if(this.data.type == "Unit"){
               if(this.data.unit){
                  return this.data.unit.offerings;
               }
            }
         }
      },
      methods: {
         ...mapActions([
            "addSelectedItem",
            "removeSelectedItem",

            "getMajor",
            "getCoMajor",
            "getMinor",
            "getUnit",
         ]),
         select(){
            if(!this.locked){
               this.$emit('clicked', this.data);
               if(!this.selected){
                  var d = this.data;
                  d.location = this.location;
                  this.addSelectedItem(d);
                  switch(this.data.type){
                     case "Unit":
                        this.credits = parseFloat(this.data.credits)
                     break;
                     case "Major":
                        this.searching = true;
                        this.getMajor(this.data.id).then(response =>{
                           this.item = response;
                           this.searching = false;
                        }).catch(err =>{
                           this.error = true;
                           this.searching = false;
                        })
                     break;
                     case "Co-Major":
                        this.searching = true;
                        this.getCoMajor(this.data.id).then(response =>{
                           this.item = response;
                           this.searching = false;
                        }).catch(err =>{
                           this.error = true;
                           this.searching = false;
                        })
                     break;
                     case "Minor":
                        this.searching = true;
                        this.getMinor(this.data.id).then(response =>{
                           this.item = response;
                           this.searching = false;
                        }).catch(err =>{
                           this.error = true;
                           this.searching = false;
                        })
                     break;
                     default:
                        //console.log(this.data.type + " clicked");
                  }
               }else{
                  var d = this.data;
                  d.location = this.location;
                  this.removeSelectedItem(d);
                  this.item = null;
                  this.credits = 0;
               }
            }
         },
         updateCredits(c){
            this.credits = this.credits + c;
         },
         closeError(){
            var d = this.data;
            d.location = this.location;
            this.removeSelectedItem(d);
            this.error = null;
         },
         openClose(){
            this.extraInfoShow = !this.extraInfoShow;
         }
      },
      watch: {
         item: function(){
            if(this.item){
               this.searching = false;
            }
         },
         credits: function(newVal, oldVal){
            this.$emit('creditUpdate', newVal-oldVal);
         },
      }
   }
</script>

